import {
    useMutation,
} from '@tanstack/react-query'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'

import requests from 'app/requests/Order/ContainersBooking.requests'
import simpleApi from 'app/services/simpleApi'
import {
    RequestData,
} from '../containerSelection.types'

type RequestParams = {
    data: RequestData,
    orderNumber: string,
    isGeneralFreight: boolean,
}

const useSaveContainerSelection = (onSuccess: () => void) => {
    const token = useJWTToken()
    const {
        onSuccess: onSuccessUpdate,
        onError,
    } = useHandleStatusRequest({
        id: 'SaveContainerSelection',
        onSuccess,
    })

    return useMutation({
        mutationFn: ({
            data,
            orderNumber,
            isGeneralFreight,
        }: RequestParams) => {
            const request = isGeneralFreight
                ? requests.updateGeneralFreights : requests.updateRequiredContainersInternal

            return simpleApi({
                ...request({
                    data,
                    orderNumber,
                }),
                token,
            })
        },
        onSuccess: onSuccessUpdate,
        onError,
    })
}

export default useSaveContainerSelection
